import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ignacio/Documents/REPOSITORY/WEBSITES/Apex-Experience/apex-next/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
